import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import {getInstallationCost} from "../../reducers/instReducer";
import Analytics from "../../analytics";
import {
  changeMessageBoxState,
  removeInstallationServiceFromCart,
  toggleInstOpened, toggleUserPopup
} from "../../actions/actionFunctions";
import {getPriceWithIncluded} from "../../misc/priceFunctions";

class ShoppingCartItemsListInstallationItem extends React.Component {

  static propTypes = {
    instItem: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
  }

  handleRemoveInstallationClick = installationService => {
    const {intl} = this.props;
    this.props.changeMessageBoxState({
      visible: true,
      message: {
        id: "shoppingCart.removeInstallationPopupQuestion",
        installationName: installationService.title
      },
      buttons: [{
        text: "shoppingCart.removeInstallationPopupNo",
        color: 'blue',
        click: () => {
          this.props.changeMessageBoxState({visible: false});
        }
      }, {
        text: intl.formatMessage({id: "shoppingCart.removeInstallationPopupYes"}),
        color: 'green',
        click: () => {
          Analytics.sendClickEvent("shopping-cart-remove-installation-" + installationService.title);
          this.props.removeInstallationServiceFromCart(installationService);
          this.props.changeMessageBoxState({visible: false});
        }
      }]
    });
  };

  toggleUserPopup = () => {
    this.props.toggleUserPopup({
      userPopupOpened: true
    })
  };

  render() {

    const {fabricatorData, instItem, isMobile, isPhoneNumberValidated, intl} = this.props;
    const {isBackend, jobId, canSaveQuote} = document.kvConfig;
    const fabricatorSettings = fabricatorData.settings;

    let showPrice = false;
    let instPrice = null;
    if (fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost && !fabricatorData.hidePricesFromUser) {
      instPrice = getInstallationCost(instItem);
      showPrice = true
    }

    const pricingIsLocked = (fabricatorSettings.leadCaptureOnQuote || fabricatorSettings.leadCaptureShoppingCart)
      && !(isBackend && jobId && canSaveQuote) && !isPhoneNumberValidated;

    return (
      <li className="scart-block__list-item">
        <div className="scart-block__list-item-text">
          <h4 className="scart-block__list-item-text-title">{instItem.title}</h4>
          <div className="scart-block__list-item-text-price">
            {/*{showPrice && isMobile ? <span className="scart-block__list-item-text-price-number">{getPriceWithCurrency(fabricatorSettings, instPrice)}</span> : null}*/}
            {/*{pricingIsLocked && isMobile ? (*/}
            {/*<span className="scart-block__list-item-text-price-locked" onClick={this.toggleUserPopup}>*/}
            {/*Pricing Locked*/}
            {/*</span>*/}
            {/*) : null}*/}
            <span className="scart-block__list-item-text-quantity">
              <FormattedMessage id="shoppingCart.footer.viewInVisualizerButton1"/> {instItem.hourly}
            </span>
          </div>
        </div>
        {instItem.autoAddWithProduct ? null : (
          isMobile ? (
              <div className="scart-block__list-item-buttons">
                <button className="ui-smallbutton ui-smallbutton--edit"
                        onClick={() => this.props.toggleInstOpened(true)}/>
                <button className="ui-smallbutton ui-smallbutton--remove"
                        onClick={() => {
                          this.handleRemoveInstallationClick(instItem)
                        }}/>
              </div>
            ) : (
              <div className="scart-block__list-item-buttons scart-block__list-item-buttons--desktop">
                <span className="link link--blue" onClick={() => this.props.toggleInstOpened(true)}>
                  <FormattedMessage id="shoppingCart.installationEditButton"/>
                </span>
                <span className="link link--red" onClick={() => this.handleRemoveInstallationClick(instItem)}>
                  <FormattedMessage id="shoppingCart.installationDeleteButton"/>
                </span>
              </div>
            )
        )}
        {showPrice ? (
          <div className="shoppingcart-block__list-item-total">
            {pricingIsLocked ? (
              <span className="price price--locked" onClick={this.toggleUserPopup}>
                <FormattedMessage id="shoppingCart.installationPricingLocked"/>
              </span>
            ) : (
              <span className="price">
                {getPriceWithIncluded(instPrice, null, fabricatorData, intl.messages)}
              </span>
            )}
          </div>
        ) : null}
      </li>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
  };
};

const mapDispatchToProps = {
  changeMessageBoxState,
  removeInstallationServiceFromCart,
  toggleInstOpened,
  toggleUserPopup
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ShoppingCartItemsListInstallationItem)
)
